export default __webpack_public_path__ + "static/media/q18_new.b4c29258.png";